import { string, shape, number, arrayOf } from 'prop-types';

const senderRemissionGuideItemPropTypes = {
  id: number.isRequired,
  description: string.isRequired,
  quantity: number.isRequired,
  weight: number,
  senderRemissionGuideId: number.isRequired,
  status: string,
  createDate: number.isRequired,
  lastUpdate: number.isRequired,
  returnDate: number,
};

const senderRemissionGuidePropTypes = {
  id: number.isRequired,
  guideNumber: string.isRequired,
  sender: string.isRequired,
  consignee: string.isRequired,
  sourceName: string.isRequired,
  destinationName: string.isRequired,
  description: string,
  createDate: number.isRequired,
  lastUpdate: number.isRequired,
  returnDate: number,
  ticket: string,
  billProcessId: number,
  billProcessStatus: string,
  response: string,
  motiveDescription: string,
  status: string,
  comment: string,
  externalId: string,
  senderRemissionGuideItemList: arrayOf(
    shape(senderRemissionGuideItemPropTypes),
  ),
};

const senderRemissionGuideDefaultProps = {
  description: null,
  returnDate: null,
  ticket: null,
  billProcessId: null,
  billProcessStatus: null,
  response: null,
  motiveDescription: null,
  status: null,
  comment: null,
  externalId: null,
  senderRemissionGuideItemList: [],
};

export {
  senderRemissionGuidePropTypes,
  senderRemissionGuideDefaultProps,
  senderRemissionGuideItemPropTypes,
};
